"use client";
import React, { useState, useCallback, useEffect } from 'react';

interface FormPhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  required?: boolean;
  className?: string;
  error?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}


const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, '').substring(0, 10);

  if (digits.length >= 7) {
    return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
  }
  if (digits.length >= 4) {
    return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
  }

  return digits;
};

export default function FormPhoneInput({
  id,
  placeholder = "(234) 567-8900",
  className = '',
  error,
  value = "",
  onChange,
  ...props
}: FormPhoneInputProps) {
  const [formattedPhone, setFormattedPhone] = useState(value);

  const handlePhoneChange = useCallback((inputValue: string) => {
    const formatted = formatPhoneNumber(inputValue);
    setFormattedPhone(formatted);
    
    
    const syntheticEvent = {
      target: { value: formatted }
    } as React.ChangeEvent<HTMLInputElement>;
    
    if (onChange) {
      onChange(syntheticEvent);
    }
    
    return formatted;
  }, [onChange]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handlePhoneChange(e.target.value);
  };

  
  useEffect(() => {
    if (value !== formattedPhone) {
      const formatted = formatPhoneNumber(value);
      setFormattedPhone(formatted);
    }
  }, [value, formattedPhone]);

  return (
    <>
      <input
        id={id}
        type="tel"
        placeholder={placeholder}
        className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#5378BC] focus:border-transparent transition-all ${
              error ? "border-red-500" : "border-gray-300"
            } ${className}`}
        value={formattedPhone}
        onChange={handleChange}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </>
  );
}
